import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'labguard-cdk'

export default function MktIcon(props) {
  return (
    <Icon {...props}>
      <span style={{ height: '100%', fontWeight: 'bold', fontStyle: 'italic', fontSize: '.7rem' }}>MKT</span>
    </Icon>
  )
}

MktIcon.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
}
